import { Switch } from "@mui/material";
import { styled } from "@mui/material/styles";

export const IOSSwitch = styled((props) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 50, // Increased width
  height: 26,
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: 1,
    "&.Mui-checked": {
      transform: "translateX(23px)", // Adjusted for wider switch
      color: "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor: "#712cf9", // Green when ON
        opacity: 1,
        border: "1px solid rgb(129, 76, 175)",
      },
    },
    "&.Mui-disabled": {
      "& + .MuiSwitch-track": {
        opacity: 0.5,
        backgroundColor: "#ccc",
      },
    },
  },
  "& .MuiSwitch-thumb": {
    width: 25,
    height: 24,
    backgroundColor: "#fff",
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
  },
  "& .MuiSwitch-track": {
    borderRadius: 26 / 2,
    backgroundColor: "#ddd",
    opacity: 1,
    transition: theme.transitions.create(["background-color", "border"]),
  },
}));
